import { render, staticRenderFns } from "./CustomMessage.vue?vue&type=template&id=4b423e12&scoped=true"
import script from "./CustomMessage.vue?vue&type=script&lang=js"
export * from "./CustomMessage.vue?vue&type=script&lang=js"
import style0 from "./CustomMessage.vue?vue&type=style&index=0&id=4b423e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b423e12",
  null
  
)

export default component.exports